import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './i18next';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
   <Suspense fallback={(<div className="content-page" style={{position:'fixed', width:'100%', height:'100vh', padding: '0'}}>
      <div style={{position:'absolute', height:'54px',width:'54px', top:'46%', left:'50%', marginLeft:'-20px', textAlign:'center'}}>
         <div className="loader" style={{height:'24px', width:'24px', borderColor:'#00880d', borderTopColor:'#ddd', margin:'auto'}}></div>
      </div>
   </div>)}>
      <App /></Suspense>
   , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
